/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useMemo, useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';
import { useMutation, ErrorTypes } from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationInfoRequest,
  getCoinbaseEngUsersAccountManagementApiApiUpdateOrganizationInfoRequestErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationInfoRequest';

type UpdateOrganizationInfoMutationArgs =
  CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationInfoRequest;

export type UpdateOrganizationInfoResult = unknown;

type HookReturnType = (
  payload: Readonly<UpdateOrganizationInfoMutationArgs>,
  options?: RequestInit,
) => Promise<UpdateOrganizationInfoResult | ErrorTypes>;

export const getUpdateOrganizationInfoUrl = () => {
  const searchParams = new URLSearchParams();
  const url = `${getBaseUrl()}/organization/v1/info${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Put UpdateOrganizationInfo
 * @Url /organization/v1/info
 * @Auth Required
 */
export const useUpdateOrganizationInfo = (): HookReturnType => {
  const mutation = useMutation<unknown, UpdateOrganizationInfoResult>();

  const callback = useCallback(
    async (payload: Readonly<UpdateOrganizationInfoMutationArgs>, options?: RequestInit) => {
      const postBody = {
        organization_id: payload.organizationId,
        legal_entity_id: payload.legalEntityId,
        organization: payload.organization,
        legal_entity: payload.legalEntity,
      };

      const init = { ...(options || {}), method: 'PUT' };

      const url = getUpdateOrganizationInfoUrl();
      const result = await mutation(url, postBody, init);

      return result;
    },
    [mutation],
  );

  return callback;
};
